import compact from 'lodash/compact'
import PropTypes from 'prop-types'
import { isEmpty } from 'ramda'
import React from 'react'
import { connect } from 'react-redux'
import { Element, scroller } from 'react-scroll'
import { compose } from 'recompose'
import { softUpdateApplicationInformation, updateApplicationInformation } from '../../actions/FlowAction'
import { getCurrentStepType } from '../../services/stepService'
import * as translationService from '../../services/translationService'
import { validateDocuments } from '../../utils/validation'
import {
  Button,
  Caption,
  DisplayText,
  ErrorText,
  Modal,
  ModalBody,
  Notice,
  Option,
  Stack,
  TextContainer,
  UploadField,
} from './../../components'
import SceneComponent from './SceneComponent'

function DocumentUploadField({
  title,
  description = null,
  limit = 99,
  income,
  errors,
  handleDocumentsChange,
  handleHandOffChange,
  incomeIndex,
  personIndex,
}) {
  return (
    <TextContainer>
      <DisplayText size="extraSmall">{title}</DisplayText>

      {description && <Caption>{description}</Caption>}
      <UploadField
        id={`files-${personIndex}-${incomeIndex}`}
        value={compact(income.documents)}
        limit={limit}
        disabled={income.handOff}
        onChange={documents => handleDocumentsChange(documents)}
        error={errors && errors.documents}
      />
      <Option
        type="checkbox"
        label={translationService.documentsHandOff()}
        id={`handOff-${personIndex}-${incomeIndex}`}
        name="handOff"
        checked={income.handOff}
        onChange={event => handleHandOffChange(event)}
      />
      {errors && errors.handOff && <ErrorText transKey={errors.handOff} />}
    </TextContainer>
  )
}

DocumentUploadField.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  income: PropTypes.object,
  errors: PropTypes.any,
  handleDocumentsChange: PropTypes.func,
  handleHandOffChange: PropTypes.func,
  incomeIndex: PropTypes.number,
  personIndex: PropTypes.number,
  limit: PropTypes.number,
  step: PropTypes.any,
}

class DocumentsScene extends SceneComponent {
  static propTypes = {
    updateApplicationInformation: PropTypes.any,
    onRef: PropTypes.any,
    application: PropTypes.any,
  }

  state = {
    contacts: [],
    infoModalIsOpen: false,
  }

  componentDidMount(...args) {
    super.componentDidMount.apply(this, args)
    const {
      inModal,
      step,
      application: { contacts, acceptDataUsages },
    } = this.props
    const isGeneralStep = getCurrentStepType(step) === 'GENERAL_STEPS'

    if (this.props.checkForError) {
      return validateDocuments({ contacts, inModal, acceptDataUsages, isGeneralStep }).catch(fieldErrors => {
        console.warn('DocumentsScene, componentDidMount', { fieldErrors })
        this.setState(
          {
            fieldErrors,
          },
          () => {
            scroller.scrollTo('mainError', {
              smooth: true,
              offset: -40, // Scrolls to element - 40 pixels down the page
              containerId: this.props.inModal && 'sceneModal',
            })
          },
        )
      })
    }
  }

  onRadioButtonChange = ({ target: { value, name } }, incomeIndex, personIndex) => {
    const { contacts } = this.props.application
    contacts[personIndex].income[incomeIndex][name] = value
    this.props.softUpdateApplicationInformation({ contacts })
  }

  onHandOffChange = ({ target: { checked, name } }, incomeIndex, personIndex) => {
    const { contacts } = this.props.application
    contacts[personIndex].income[incomeIndex][name] = checked
    this.props.softUpdateApplicationInformation({ contacts })
  }

  // onChange = ({ target: { value, id } }) => {
  //   this.setState({ [id]: value })
  // }

  onDocumentsChange = (documents, incomeIndex, personIndex) => {
    this.setState({ fieldErrors: [] })
    const { contacts } = this.props.application
    contacts[personIndex].income[incomeIndex].documents = documents
    this.props.softUpdateApplicationInformation({ contacts })
  }

  onSubmit = async (shouldValidate = true) => {
    const { contacts, finishedStep, acceptDataUsages } = this.props.application
    const { step, inModal } = this.props
    const isGeneralStep = getCurrentStepType(step) === 'GENERAL_STEPS'

    if (shouldValidate) {
      try {
        await validateDocuments({ contacts, inModal, acceptDataUsages, isGeneralStep })
        return this.props.updateApplicationInformation({
          contacts,
          finishedStep: { ...finishedStep, [step]: true, 0: true },
        })
      } catch (fieldErrors) {
        this.setState(
          {
            fieldErrors,
          },
          () => {
            scroller.scrollTo('mainError', {
              smooth: true,
              offset: -40, // Scrolls to element - 40 pixels down the page
              containerId: this.props.inModal && 'sceneModal',
            })
          },
        )
        throw fieldErrors
      }
    } else {
      return this.props.updateApplicationInformation({ contacts })
    }
  }

  toggleModal = () => {
    this.setState(prevState => {
      return { infoModalIsOpen: !prevState.infoModalIsOpen }
    })
  }

  handleAcceptDataUsages = ({ target: { checked } }) => {
    this.props.softUpdateApplicationInformation({ acceptDataUsages: checked })
  }

  render() {
    const { fieldErrors = [] } = this.state
    const { inModal, step } = this.props
    const { contacts, acceptDataUsages } = this.props.application
    const isGeneralStep = getCurrentStepType(step) === 'GENERAL_STEPS'
    // 'Interim': Last 3 wage checks (laatste 3 loonbriefjes)
    // 'Servant undefined duration': Last 3 wage checks (laatste 3 loonbriefjes)
    // 'Servant defined duration': Last 3 wage checks (laatste 3 loonbriefjes)
    // 'Independant':

    return (
      <div>
        <TextContainer>
          {!inModal && <DisplayText>{translationService.documentsTitle()}</DisplayText>}
          {!inModal && (
            <p>
              {translationService.documentIntro()}
              <br />
              <Button onClick={this.toggleModal} plain>
                {translationService.documentMoreInfoAction()}
              </Button>
            </p>
          )}
          {!isEmpty(fieldErrors) && (
            <Element name="mainError">
              <Notice type="error">{translationService.intakeFormErrors()}</Notice>
            </Element>
          )}
          {contacts.map(
            (person, personIndex) =>
              person.income.length ? (
                <TextContainer key={personIndex} asCard={true}>
                  <Stack distribution="equalSpacing">
                    <DisplayText size="small">
                      {person.firstname} {person.lastname}
                    </DisplayText>
                    {/*personIndex > 0 && (
                  <Button plain>
                    <Icon source="bin" />
                  </Button>
                )*/}
                  </Stack>
                  {person.income.map((income, incomeIndex) => {
                    const props = {
                      income,
                      personIndex,
                      incomeIndex,
                      handleDocumentsChange: documents => this.onDocumentsChange(documents, incomeIndex, personIndex),
                      handleHandOffChange: event => this.onHandOffChange(event, incomeIndex, personIndex),
                    }

                    if (fieldErrors.contacts && fieldErrors.contacts[personIndex]) {
                      props.errors = fieldErrors.contacts[personIndex].income[incomeIndex]
                    }
                    switch (income.id) {
                      case 'INTAKE_INCOME_SALARY':
                        props.title = translationService.documentsPayslipTitle()
                        props.description = translationService.documentsPayslipDescription()
                        break
                      case 'INTAKE_INCOME_SAVINGS':
                        props.title = translationService.documentsProofOfSavingsTitle()
                        props.description = translationService.documentsProofOfSavingsDescription()
                        break
                      case 'INTAKE_INCOME_PENSION':
                        props.title = translationService.documentsProofOfRetirementPaymentTitle()
                        props.description = translationService.documentsProofOfRetirementPaymentDescription()
                        break
                      case 'INTAKE_INCOME_DOLE':
                        props.title = translationService.documentsDoleTitle()
                        props.description = translationService.documentsDoleDescription()
                        break
                      case 'INTAKE_INCOME_ALIMONY':
                        props.title = translationService.documentsAlimonyTitle()
                        props.description = translationService.documentsALimonyDescription()
                        break
                      case 'INTAKE_INCOME_CHILDBENEFIT':
                        props.title = translationService.documentsChildBenefitTitle()
                        props.description = translationService.documentsChildBenefitDescription()
                        break
                      case 'INTAKE_INCOME_INTERESTS':
                        props.title = translationService.documentsInterestsTitle()
                        props.description = translationService.documentsInterestsDescription()
                        break
                      case 'INTAKE_INCOME_OTHER':
                        props.title = translationService.documentsOtherTitle()
                        props.description = translationService.documentsOtherDescription()
                        break
                    }
                    return <DocumentUploadField key={incomeIndex} {...props} />
                  })}
                </TextContainer>
              ) : null,
          )}
          {!inModal &&
            !isGeneralStep && (
              <Option
                type="checkbox"
                label={translationService.overviewAcceptDataUsage()}
                id="acceptDataUsages"
                name="acceptDataUsages"
                checked={acceptDataUsages}
                onChange={this.handleAcceptDataUsages}
                hasError={fieldErrors && fieldErrors.acceptDataUsages}
              />
            )}
        </TextContainer>
        <Modal
          isOpen={this.state.infoModalIsOpen}
          onRequestClose={this.toggleModal}
          title={translationService.documentMoreInfoTitle()}>
          <ModalBody>{translationService.documentMoreInfoText()}</ModalBody>
        </Modal>
      </div>
    )
  }
}

const mapStateToProps = ({ FlowReducer }) => {
  const { application, step } = FlowReducer
  return {
    application,
    step,
  }
}
const mapDispatchToProps = dispatch => ({
  updateApplicationInformation: information => dispatch(updateApplicationInformation(information)),
  softUpdateApplicationInformation: information => dispatch(softUpdateApplicationInformation(information)),
})

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(DocumentsScene)



// WEBPACK FOOTER //
// ./src/views/scenes/DocumentsScene.js